export const DOUBLE_CARD_NO_ISSUANCE_ALTERNATIVE_FLIGHTS_RESULTS = 'SSE_FC5392';
export const DOUBLE_CARD_ISSUANCE_ALTERNATIVE_FLIGHTS_RESULTS = 'SSE_FC5638';

export const FEEDBACK_TAB_DESKTOP = 'SSE_FC4838';

export const META_LANDING_IN_OF2_MOBILE = 'PRIME_TITANS83M';
export const META_LANDING_IN_OF2_DESKTOP = 'PRIME_TITANS83D';

export const PRICEFREEZE_REDUCE_CANNIBALIZATION = 'fan_plus_9520';
export const PRICEFREEZE_PRIME_FIRST_PHASE_2_DESKTOP = 'FAN_PLUS9571';

export const PERSONALISED_DECORATION = 'SSE_FC5243';

export const ALTERNATIVE_FLIGHTS_BOOKINGS_OPTIMIZATION_PRIME_REPEAT =
  'SSE_FC5727PR';

export const ALTERNATIVE_FLIGHTS_BOOKINGS_OPTIMIZATION_PRIME_REPEAT_LAYER =
  'SSE_FC5692PR';

export const PRIME_DISCOUNT_VISIBILITY = 'SSE_FC5452';
export const INCREASE_RECOGNIZED_USERS_MOBILE = 'FAN_PLUS9355';

export const PRICE_FREEZE_PRIME_FIRST_PHASE_2_MOBILE = 'FAN_PLUS9570';

export const ALTERNATIVE_FLIGHTS_BROKEN_FLOW = 'SSE_FC5946';

export const PRIME_DAYS_BANNER_MOBILE = 'SSE_FC3610';

export const PRIME_DAY_VERSIONED_COMPONENT = 'SSE_FC3610';

export const HOTEL_SUPERSALE_COUNTDOWN = 'FRO_OFIS2786';

export const CAMPAIGNS_COUNTDOWN_ALIAS = 'FRO_OFIS3010';

export const FLIGHT_OF_THE_DAY_DECORATION = 'SSE_FC6059';

export const PRIME_DAYS = 'SSE_FC3610';

export const RESIDENT_DISCLAIMER = 'FBO_BOOK3259';

export const RESIDENT_DISCLAIMER_MESSAGE = 'FBO_BOOK3259_PAXTYPE';

export const PRIME_DAYS_DRAWER_APP = 'FRO_OFIS2437';

export const SHOPPING_CART_WITH_CHEAPEST = 'SSE_FC3865';

export const ITINERARY_DEAL_MOBILE = 'MFS_MFS1752';

export const SORTING_PROVIDER_MOBILE = 'MFS_MFS1752';

export const SOLD_OUT_RESULTS_MOBILE = 'MFS_MFS1752';

export const HIGHLIGHTED_PILL = 'MFS_MFS1752';

export const DEAL_PRICE_MOBILE = 'MFS_MFS1752';

export const FECO_CHECKOUT_PASSENGERS_MOBILE = 'COUNTER_COUNTER925';

export const FECO_CHECKOUT_PASSENGERS_DESKTOP = 'COUNTER_COUNTER925D';

export const STANDARD_CARD_UK_MOBILE = 'SSE_FC4128';

export const BAGS_SEATS_CROSS_SELLING = 'ALT_ALT4135_M';

export const TICKETS_LEFT = 'SSE_FC4237D';

export const SEM_RESULTS = 'SSE_FC4587';

export const FLEXIBLE_DATES_RT_DESKTOP = 'SSE_FC4489';

export const FLEXIBLE_DATES_RT_MOBILE = 'SSE_FC4489M';

export const PRICE_FREEZE_DESKTOP = 'FAN_PLUS7920_D';

export const PRICE_FREEZE_MOBILE = 'FAN_PLUS7920_M';

export const PRIME_FREEZE_DESKTOP = 'FAN_PLUS9180_D';

export const ITINERARY_PRICE_ALIGN_RIGHT_DESKTOP = 'SSE_FC3712';

export const PIN_SEGMENT = 'SSE_FC4681';

export const PRIME_MARKET = 'ULC_UNL293';

export const FAVORITES_RESULTS = 'SSE_FC4806';

export const SEM_ITERATIVE_FIXES = 'SSE_FC4879';

export const RETAILING_TECHNIQUES = 'SSE_FC4900';

export const HOTEL_VOUCHER = 'SSE_FC5034';

export const QUALITY_TAG = 'SSE_FC5125';

export const AIRCRAFT_FILTER = 'SSE_FC5115';

export const GOOGLE_SEO_DISPLAY = 'SSE_FC5206';

export const INVOLUNTARY_CHURN_PREDICTION = 'SSE_FC6235';

export const RAILS_MVP = 'SSE_FC6301';

export const RAILS_EARLIEST_SORTING = 'SSE_FC6534';

export const EDO_CONTEST = 'SSE_FC6341';

export const COGNITIVE_OVERLOAD = 'PRIME_TITANS527';

export const UNBUNDLED_RESULTS = 'SSE_FC6330';

export const ALTERNATIVE_FLIGHT_BOOKABLE = 'SSE_FC6439_B';

export const ALTERNATIVE_FLIGHT_NON_BOOKABLE = 'SSE_FC6439_NB';

export const FILTER_PILLS_DESKTOP = 'SSE_FC6418';

export const FILTER_PILLS_MOBILE = 'SSE_FC6488';

export const APP_DOWNLOAD_OVERLAY_SEM = 'SSE_FC6544';

export const UNBUNDLE_RESULTS = 'SSE_FC6633';

// Version 2
export const TOGGLE_PRIME_OPTIMIZATION = 'sse_fc-6293';

export const NO_RESULTS_FILTER_REDESIGN = 'SSE_FC6524';

//Unbundle
export const SEARCH_ITINERARIES = 'SSE_FC6622';

export const RAILS_BAGGAGE_INFORMATION = 'SSE_FC6433';

export const SIMPLIFIED_RESULTS_META = 'PRIME_TITANS10494';

export const EQUAL_PROMINENCE_IT_4_MOBILE = 'PRIME_HOT5376';
